import { render, staticRenderFns } from "./AddVideoDrawer.vue?vue&type=template&id=674a23d8&scoped=true"
import script from "./AddVideoDrawer.vue?vue&type=script&lang=js"
export * from "./AddVideoDrawer.vue?vue&type=script&lang=js"
import style0 from "./AddVideoDrawer.vue?vue&type=style&index=0&id=674a23d8&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "674a23d8",
  null
  
)

export default component.exports